import React from 'react';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Props } from './ui/modal/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ConfigureFieldsModal = lazy(
	() => import(/* webpackChunkName: "async-issue-create-configure-fields" */ './index'),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) =>
	fg('error_boundaries_to_common_package') ? (
		<JiraIssueCreateErrorBoundary
			id="async.jira.issue-create.configure-fields"
			packageName="jiraIssueCreateConfigureFields"
		>
			<Placeholder name="create-configure-fields-modal" fallback={<></>}>
				<ConfigureFieldsModal {...props} />
			</Placeholder>
		</JiraIssueCreateErrorBoundary>
	) : (
		<ErrorBoundary
			id="async.jira.issue-create.configure-fields"
			packageName="jiraIssueCreateConfigureFields"
		>
			<Placeholder name="create-configure-fields-modal" fallback={<></>}>
				<ConfigureFieldsModal {...props} />
			</Placeholder>
		</ErrorBoundary>
	);
